import { render, staticRenderFns } from "./kalrez.vue?vue&type=template&id=0e0429ce&scoped=true&"
import script from "./kalrez.vue?vue&type=script&lang=js&"
export * from "./kalrez.vue?vue&type=script&lang=js&"
import style0 from "./kalrez.vue?vue&type=style&index=0&id=0e0429ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0429ce",
  null
  
)

export default component.exports